export default __webpack_public_path__ + "static/1-2b42420ea0875fb771cd63ab041a264e.jpeg";